<template>

  <div class="other-services">

    <text-and-image class="shadowed">
      <template v-slot:image>
        <img src="../assets/man_and_lorry.jpg" class="man-and-lorry" alt="Man in front of lorry holding clipboard"/>
      </template>
      <template v-slot:header>Transport Services</template>
      <template v-slot:text>
        <p>Dave Bennett Distribution is specialised in providing the best possible solutions for different transport services. We aim to support your business by giving a helping hand in various areas of transportation.</p>
        <p>Dave Bennett Distribution can help your business by providing the following transportation solutions:</p>
        <ul class="branded-list branded-list--two-columns">
          <li>Container Transport</li>
          <li>Refrigerated Transport</li>
          <li>Curtain Sided Transport</li>
        </ul>
        <p>If you would like to learn more about our areas of services, and which mode of transport we use, or if you have a job in mind that we can quote for, please get in touch with us, or give us a call.</p>
        <div>
          <router-link to="contact" class="branded-button">Ask about our transport services</router-link>
        </div>
      </template>
    </text-and-image>

    <text-and-image class="shadowed" reversed>
      <template v-slot:image>
        <img src="../assets/container_storage.jpg" alt="Man taking boxes out of container">
      </template>
      <template v-slot:header>Personal Storage</template>
      <template v-slot:text>
        <p>We are offering a wide variety of storage options on site. These storage options have different variations they mainly range from Xft to XXft large containers.</p>
        <p>Our containers are available for both short and long term usage. They are equipped with the latest technology and advanced options, with complete security and CCTV system.</p>
        <p>Dave Bennett Distribution offers you 24 hours access to your storage.</p>
        <div>
          <router-link to="contact" class="branded-button">Get in touch about our storage options</router-link>
        </div>
      </template>
    </text-and-image>

    <text-and-image class="shadowed">
      <template v-slot:image>
        <img src="../assets/parked_lorries.jpg" alt="Lorries parked in a row">
      </template>
      <template v-slot:header>Lorry / Trailer Parking</template>
      <template v-slot:text>
        <p>If you are thinking about a good service related to lorry or trailer parking, then you are in the right place. We are always there to help you.</p>
        <p>Our yard has ample space that can be served for lorry or trailer parking. The parking space is monitored and checked daily.</p>
        <p>Moreover, it has a sound security system to keep everything protected.</p>
        <div>
          <router-link to="contact" class="branded-button">Ask about overnight parking</router-link>
        </div>
      </template>
    </text-and-image>

  </div>



</template>

<script>
  import TextAndImage from "../components/text-and-image";
  export default {
    components: {TextAndImage}
  }
</script>

<style>


</style>